/* eslint-disable jira/filename-case */
import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return (
			// eslint-disable-next-line jira/ff/no-preconditioning
			fg('jira_preview_panel_m_1_rollout') && fg('jira-glance-panel')
		);
	},
};
